import {
    TOOLBAR
} from "../action-types";

const initState: any = {
    modules: {
        template: {
            name: "模板",
            value: [{key: "default", name: "默认模板", value: 0}]
        },
        color: {
            name: "配色",
            value: 0
        },
        // control: {
        //     name: '控件',
        //     value: ''
        // },
        // tools: {
        //     name: '小工具',
        //     value: ''
        // }
    },
    userConfig: {},
    color: ""
};
export default function toolbarReducer(state = initState, action: any) {
    switch (action.type) {
        /* 模块内容 */
        case TOOLBAR.MODULES:
            return Object.assign({}, state, {modules: action.payload});
        /* 配置信息 */
        case TOOLBAR.CONFIG:
            return Object.assign({}, state, {userConfig: action.payload});
        /* 配色 */
        case TOOLBAR.COLOR:
            return Object.assign({}, state, {color: action.payload});
        default:
            return state;
    }
}
